(function () {
  'use strict';

  function resetWaitlistForm(form) {
    var submit = form.querySelector('[data-waitlist-submit]');
    if (!submit) return;
    submit.textContent = submit.dataset.defaultLabel || submit.textContent;
    form.removeAttribute('aria-busy');
  }

  function getStoredWaitlistTarget() {
    try {
      return window.sessionStorage.getItem('escosyWaitlistTarget') || '';
    } catch (error) {
      return '';
    }
  }

  function getHashWaitlistTarget() {
    try {
      return decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return window.location.hash.slice(1);
    }
  }

  function normalizeWaitlistTarget(forms, candidate) {
    if (!candidate) return '';
    var matchingForm = Array.prototype.find.call(forms, function (form) {
      return form.dataset.waitlistAnchor === candidate || form.id === candidate;
    });
    return matchingForm ? matchingForm.dataset.waitlistAnchor : '';
  }

  function getWaitlistResponseTarget(forms, hashTarget, storedTarget) {
    if (hashTarget) return hashTarget;
    if (storedTarget) return storedTarget;

    var firstResponse = Array.prototype.find.call(forms, function (form) {
      return form.querySelector('[data-waitlist-feedback]');
    });
    return firstResponse ? firstResponse.dataset.waitlistAnchor : '';
  }

  function reconcileWaitlistFeedback(forms) {
    var storedTarget = normalizeWaitlistTarget(forms, getStoredWaitlistTarget());
    var hashTarget = normalizeWaitlistTarget(forms, getHashWaitlistTarget());
    var responseTarget = getWaitlistResponseTarget(forms, hashTarget, storedTarget);
    var clientSuccessTarget = storedTarget && storedTarget === hashTarget ? storedTarget : '';
    var focusedResponse = false;
    var handledResponse = false;

    Array.prototype.forEach.call(forms, function (form) {
      var feedback = form.querySelector('[data-waitlist-feedback]');
      var clientSuccess = form.querySelector('[data-waitlist-client-success]');

      if (!feedback && clientSuccess && form.dataset.waitlistAnchor === clientSuccessTarget) {
        feedback = clientSuccess;
      }
      if (clientSuccess && clientSuccess !== feedback) clientSuccess.hidden = true;
      if (!feedback) return;

      var isResponseTarget = form.dataset.waitlistAnchor === responseTarget;
      var field = form.querySelector('.product-waitlist__field');
      var consent = form.querySelector('.product-waitlist__consent');
      var input = form.querySelector('input[type="email"]');

      if (!isResponseTarget) {
        feedback.hidden = true;
        if (field) field.hidden = false;
        if (consent) consent.hidden = false;
        if (input) {
          input.removeAttribute('aria-invalid');
          if (consent) input.setAttribute('aria-describedby', consent.id);
        }
        return;
      }

      handledResponse = true;
      feedback.hidden = false;
      if (feedback.dataset.waitlistResult === 'success') {
        if (field) field.hidden = true;
        if (consent) consent.hidden = true;
      }

      if (!focusedResponse) {
        focusedResponse = true;
        window.requestAnimationFrame(function () {
          feedback.focus({ preventScroll: true });
        });
      }
    });

    if (handledResponse) {
      try {
        window.sessionStorage.removeItem('escosyWaitlistTarget');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes.
      }
    }
  }

  function initWaitlistForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.product-waitlist__form');

    Array.prototype.forEach.call(forms, function (form) {
      var waitlistSection = form.closest('[data-product-waitlist]');
      if (waitlistSection) form.dataset.waitlistAnchor = waitlistSection.id;
      if (form.dataset.waitlistInit === 'true') return;
      form.dataset.waitlistInit = 'true';

      var submit = form.querySelector('[data-waitlist-submit]');
      if (submit) {
        submit.dataset.defaultLabel = submit.textContent.trim();
        form.addEventListener('submit', function () {
          try {
            window.sessionStorage.setItem('escosyWaitlistTarget', form.dataset.waitlistAnchor);
          } catch (error) {
            // Storage can be unavailable in strict privacy modes.
          }

          submit.textContent = submit.dataset.pendingLabel || 'Joining…';
          form.setAttribute('aria-busy', 'true');
          window.setTimeout(function () {
            resetWaitlistForm(form);
          }, 12000);
        });
      }
    });

    reconcileWaitlistFeedback(forms);
  }

  function resetWaitlistForms() {
    document.querySelectorAll('.product-waitlist__form').forEach(function (form) {
      resetWaitlistForm(form);
    });
  }

  initWaitlistForms(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWaitlistForms(event.target);
  });

  window.addEventListener('pageshow', function () {
    resetWaitlistForms();
  });
})();
